import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import { asLabel } from '@shure/shared/models';

@Component({
	selector: 'sh-maintenance',
	imports: [CommonModule, TranslocoModule],
	templateUrl: './maintenance.component.html',
	styleUrl: './maintenance.component.scss',
	standalone: true
})
export class MaintenanceComponent {
	public title = input<string>(asLabel('cloud.shared.maintenance.we-will-be-back-soon'));
	public description = input<string>(asLabel('cloud.shared.maintenance.inconvenience-maintenance-text'));
	public showRibbon = input<boolean>(true);
	public startAt = input<string>('');
	public endAt = input<string>('');
}
